import Swiper from "swiper";
import { Pagination, EffectFade } from "swiper/modules";
import gsap, { Linear } from "gsap";

export const caseStudies = () => {
    const el = document.querySelector(".case-studies");
    el && init(el);
};

const init = el => {
    const duration = parseInt(el.dataset.duration);
    const slider = document.querySelector(".case-studies__slider .swiper");
    const accordionTriggers = document.querySelectorAll(".case-studies__accordion__trigger");
    const cards = slider.querySelectorAll(".card-case-study");
    const pagination = document.querySelector(".case-studies__pagination");

    const paginationLabels = [];
    cards.forEach(card => {
        paginationLabels.push(card.dataset.label);
    });

    accordionTriggers.forEach(trigger => {
        trigger.addEventListener("click", e => {
            swiper.slideTo(parseInt(e.target.dataset.goto));
        });
    });

    const tl = gsap.timeline({
        defaults: {
            ease: Linear.easeNone,
            duration,
        },
    });
    tl.fromTo(
        el,
        {
            "--progress": 0,
        },
        {
            "--progress": 1,
            onComplete: () => {
                swiper.isEnd ? swiper.slideTo(0) : swiper.slideNext();
            },
        }
    );

    const swiper = new Swiper(slider, {
        modules: [Pagination, EffectFade],
        slidesPerView: "auto",
        speed: 650,
        keyboard: true,
        a11y: true,
        runCallbacksOnInit: false,
        touchStartPreventDefault: false,
        preventClicksPropagation: false,
        preventClicks: true,
        slideToClickedSlide: false,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
            el: pagination,
            clickable: true,
            renderBullet: function(index, className) {
                return `<button type="button" class="case-studies__paginationitem ${className}">
                    <span class="text">${paginationLabels[index]}</span>
                    <span class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14"><path fill="currentColor" d="M6.5 13.2c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1l3.8-3.8.3-.3H1C.6 7.8.2 7.4.2 7s.4-.8.8-.8h9.1c-.1-.1-.2-.2-.3-.4L6 2c-.3-.3-.3-.7 0-1s.7-.3 1 0l3.8 3.8C12 6 12 8 10.8 9.2L7 13c-.1.2-.3.2-.5.2z" /></svg>
                    </span>
                </button>`;
            },
        },
        breakpoints: {
            768: {
                allowTouchMove: true,
            },
        },
        on: {
            slideChangeTransitionStart: () => {
                tl.restart();
            },
        },
    });
};
